import ContentCardBodyV4 from '../../common/component/ContentCardBodyV4';
import {useContentEvent} from '../../content/hook/useContentEvent';
import {sendViewerEvent} from '../../viewer/common';
import {sendViewerViewImp} from '../../viewer/common';
import {IOriginalNovel} from '../type';

interface IProps {
  originalNovel: IOriginalNovel;
  sizeClassName: string;
  referrerId: number;
  bgColorRgb?: string;
  isViewer?: boolean;
}

export default function KakaopageContentCard({
  originalNovel,
  sizeClassName,
  referrerId,
  bgColorRgb: _bgColorRgb,
  isViewer,
}: IProps) {
  const {sendContentEvent, sendContentViewImp} =
    useContentEvent('content_info');
  const {content} = originalNovel;
  const bgColorRgb = _bgColorRgb || content.bgColorRgb;
  const onClick = () => {
    isViewer
      ? sendViewerEvent({
          actionName: 'kp_novel',
          action: 'click',
          customProps: {
            ordnum: 1,
            event_layer: 'kp_novel',
            viewer_type: 'scroll',
          },
        })
      : sendContentEvent({
          actionName: 'kp_novel',
          action: 'click',
          customProps: {ordnum: 1, event_layer: 'kp_novel'},
        });

    const referrer = encodeURIComponent(
      `t_src=kakao_webtoon&t_ch=${location.pathname}&t_obj=${referrerId}` +
        `&utm_source=kakao_webtoon&utm_medium=${location.pathname}&utm_campaign=${referrerId}`
    );
    const url = `https://link-page.kakao.com/open/content?series_id=${content.id}&referrer=${referrer}`;
    location.assign(url);
  };

  return (
    <div className={cn('overflow-hidden', sizeClassName)}>
      <ContentCardBodyV4
        content={{...content, sid: '', thumbImg: '', bgColorRgb}}
        onClick={onClick}
        onIntersection={() =>
          isViewer
            ? sendViewerViewImp({
                customProps: {event_layer: 'kp_novel', view_type: 'scroll'},
              })
            : sendContentViewImp({
                customProps: {ordnum: 1, event_layer: 'kp_novel'},
              })
        }
        bgScaleClassName="scale-1"
        titleImageClassName="!w-full !max-w-[150px]"
      />
    </div>
  );
}
